import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function usePerson(formattedName) {
  const [person, setPerson] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchPerson() {
      if (!formattedName) {
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        setError(null)

        // Convert formatted name back to regular name for lookup
        const searchName = formattedName.replace(/_/g, ' ').toLowerCase()
        
        const { data, error: fetchError } = await supabase
          .from('people')
          .select('*')
          .ilike('name', `%${searchName}%`)
          .single()

        if (fetchError) {
          throw fetchError
        }

        // Transform the data to match the existing structure
        const transformedPerson = {
          name: data.name,
          image: data.image ? (data.image.startsWith('http') ? data.image : process.env.PUBLIC_URL + data.image) : process.env.PUBLIC_URL + "/images/defaultpic.png",
          title: data.title,
          bio: data.bio,
          linkedin: data.linkedin,
          website: data.website,
          email: data.email,
          github: data.github,
          projectsCategory: data.projects_category ? data.projects_category.split(',').map(cat => cat.trim()) : [],
          id: data.id,
          createdAt: data.created_at,
          updatedAt: data.updated_at
        }

        setPerson(transformedPerson)
      } catch (err) {
        console.error('Error fetching person:', err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchPerson()
  }, [formattedName])

  return { person, loading, error }
}
